function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const colors = {
  error: "var(--notification-error)",
  warning: "var(--notification-warning)",
  information: "var(--notification-information)",
  info: "var(--notification-information)",
  success: "var(--notification-success)",
  text: "var(--icon-secondary)",
  disabled: "var(--icon-primary-disabled)",
  "on-color": "var(--icon-reversed)"
};
const resolveParams = (color, size, style) => {
  const colorResolved = colors[color];
  let result = {
    ...style
  };
  if (colorResolved) {
    result["--icon-primary"] = colorResolved;
    result["--icon-2colors-stroke"] = colorResolved;
    if (color === "disabled") {
      //only for 2-colors icon
      result["--icon-2colors-stroke"] = "var(--icon-2colors-stroke-disabled)";
      result["--chart-11"] = "var(--icon-2colors-fill-disabled)";
    }
  }
  if (size) {
    result.height = size;
    result.width = size;
  }
  return result;
};
export const ActionsMenuIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Actions-menu"
}, "Actions menu"), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 18C10.5 17.6022 10.658 17.2206 10.9393 16.9393C11.2206 16.658 11.6022 16.5 12 16.5C12.3978 16.5 12.7794 16.658 13.0607 16.9393C13.342 17.2206 13.5 17.6022 13.5 18C13.5 18.3978 13.342 18.7794 13.0607 19.0607C12.7794 19.342 12.3978 19.5 12 19.5C11.6022 19.5 11.2206 19.342 10.9393 19.0607C10.658 18.7794 10.5 18.3978 10.5 18ZM10.5 12C10.5 11.6022 10.658 11.2206 10.9393 10.9393C11.2206 10.658 11.6022 10.5 12 10.5C12.3978 10.5 12.7794 10.658 13.0607 10.9393C13.342 11.2206 13.5 11.6022 13.5 12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5C11.6022 13.5 11.2206 13.342 10.9393 13.0607C10.658 12.7794 10.5 12.3978 10.5 12ZM10.5 6C10.5 5.60218 10.658 5.22064 10.9393 4.93933C11.2206 4.65803 11.6022 4.5 12 4.5C12.3978 4.5 12.7794 4.65803 13.0607 4.93933C13.342 5.22064 13.5 5.60218 13.5 6C13.5 6.39782 13.342 6.77936 13.0607 7.06067C12.7794 7.34197 12.3978 7.5 12 7.5C11.6022 7.5 11.2206 7.34197 10.9393 7.06067C10.658 6.77936 10.5 6.39782 10.5 6Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const ActionsMenuCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Actions-menu-circle"
}, "Actions menu circle"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12ZM24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 13.5C16.6022 13.5 16.2206 13.342 15.9393 13.0607C15.658 12.7794 15.5 12.3978 15.5 12C15.5 11.6022 15.658 11.2206 15.9393 10.9393C16.2206 10.658 16.6022 10.5 17 10.5C17.3978 10.5 17.7794 10.658 18.0607 10.9393C18.342 11.2206 18.5 11.6022 18.5 12C18.5 12.3978 18.342 12.7794 18.0607 13.0607C17.7794 13.342 17.3978 13.5 17 13.5ZM12 13.5C11.6022 13.5 11.2206 13.342 10.9393 13.0607C10.658 12.7794 10.5 12.3978 10.5 12C10.5 11.6022 10.658 11.2206 10.9393 10.9393C11.2206 10.658 11.6022 10.5 12 10.5C12.3978 10.5 12.7794 10.658 13.0607 10.9393C13.342 11.2206 13.5 11.6022 13.5 12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5ZM7 13.5C6.60218 13.5 6.22064 13.342 5.93933 13.0607C5.65803 12.7794 5.5 12.3978 5.5 12C5.5 11.6022 5.65803 11.2206 5.93933 10.9393C6.22064 10.658 6.60218 10.5 7 10.5C7.39782 10.5 7.77936 10.658 8.06067 10.9393C8.34197 11.2206 8.5 11.6022 8.5 12C8.5 12.3978 8.34197 12.7794 8.06067 13.0607C7.77936 13.342 7.39782 13.5 7 13.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const ArrowDownIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Arrow-down"
}, "Arrow down"), /*#__PURE__*/React.createElement("path", {
  d: "M12.2123 4C11.8153 4 11.4934 4.31382 11.4934 4.70094L11.4934 17.6076L8.22844 14.498C7.94831 14.2236 7.49312 14.2226 7.21173 14.4957C6.93034 14.7689 6.92931 15.2127 7.20943 15.487L11.5923 19.7934C11.7459 19.9438 11.952 20.012 12.1534 19.998C12.3546 20.0129 12.5611 19.9455 12.7153 19.7958L16.9517 15.6693C17.2331 15.3961 17.2341 14.9523 16.954 14.678C16.6739 14.4036 16.2187 14.4026 15.9373 14.6757L12.9312 17.6081L12.9312 4.70094C12.9312 4.31382 12.6094 4 12.2123 4Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const ArrowLeftIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Arrow-left"
}, "Arrow left"), /*#__PURE__*/React.createElement("path", {
  d: "M19.998 12.2585C19.998 11.8614 19.6842 11.5395 19.2971 11.5395L6.39047 11.5395L9.50006 8.27458C9.77441 7.99446 9.77542 7.53926 9.5023 7.25787C9.22918 6.97648 8.78537 6.97545 8.51102 7.25557L4.2047 11.6384C4.05429 11.792 3.98603 11.9982 4.00007 12.1995C3.98518 12.4007 4.05253 12.6072 4.20223 12.7614L8.32879 16.9978C8.60191 17.2792 9.04572 17.2802 9.32007 17.0001C9.59442 16.72 9.59543 16.2648 9.32231 15.9834L6.38992 12.9774L19.2971 12.9774C19.6842 12.9774 19.998 12.6555 19.998 12.2585Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const ArrowRightIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Arrow-right"
}, "Arrow right"), /*#__PURE__*/React.createElement("path", {
  d: "M3.99805 12.2585C3.99805 11.8614 4.31187 11.5395 4.69899 11.5395L17.6056 11.5395L14.496 8.27458C14.2217 7.99446 14.2207 7.53926 14.4938 7.25787C14.7669 6.97648 15.2107 6.97545 15.4851 7.25557L19.7914 11.6384C19.9418 11.792 20.0101 11.9982 19.996 12.1995C20.0109 12.4007 19.9436 12.6072 19.7939 12.7614L15.6673 16.9978C15.3942 17.2792 14.9504 17.2802 14.676 17.0001C14.4017 16.72 14.4007 16.2648 14.6738 15.9834L17.6062 12.9774L4.69899 12.9774C4.31187 12.9774 3.99805 12.6555 3.99805 12.2585Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const ArrowUpIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Arrow-up"
}, "Arrow up"), /*#__PURE__*/React.createElement("path", {
  d: "M11.951 20C12.3481 20 12.6699 19.6862 12.6699 19.2991L12.6699 6.39242L15.9349 9.50201C16.215 9.77637 16.6702 9.77737 16.9516 9.50425C17.233 9.23114 17.234 8.78733 16.9539 8.51297L12.5711 4.20665C12.4175 4.05624 12.2113 3.98799 12.01 4.00202C11.8087 3.98713 11.6023 4.05448 11.448 4.20418L7.21165 8.33074C6.93026 8.60386 6.92923 9.04767 7.20935 9.32202C7.48947 9.59638 7.94467 9.59738 8.22606 9.32426L11.2321 6.39187L11.2321 19.2991C11.2321 19.6862 11.554 20 11.951 20Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const BreadcrumbsArrowIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Breadcrumbs-arrow"
}, "Breadcrumbs arrow"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.8408 11.1096L9.94678 7.16156C9.84197 7.05805 9.70102 7 9.55371 7C9.4064 7 9.26497 7.05805 9.16016 7.16156C9.05755 7.26845 9 7.41088 9 7.55905C9 7.70722 9.05755 7.84966 9.16016 7.95656L12.667 11.4996L9.16016 15.0426C9.05755 15.1495 9 15.2919 9 15.4401C9 15.5882 9.05755 15.7307 9.16016 15.8376C9.26497 15.9411 9.4064 15.9991 9.55371 15.9991C9.70102 15.9991 9.84197 15.9411 9.94678 15.8376L13.8408 11.9036C13.9431 11.7967 14.0005 11.6545 14.0005 11.5066C14.0005 11.3586 13.9431 11.2164 13.8408 11.1096Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const CardArrowCollapseIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Card-arrow-collapse"
}, "Card arrow collapse"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.816 15.8491L20.9689 16.0469C20.7962 16.1803 20.5842 16.2527 20.366 16.2527C20.1479 16.2527 19.9358 16.1803 19.7632 16.0469L19.7564 16.0416L11.9829 9.5957L4.1825 16.0515L4.16944 16.0599C3.99757 16.1694 3.79603 16.2232 3.5924 16.2139C3.38937 16.2046 3.19415 16.1329 3.0333 16.0088C2.95211 15.9473 2.88498 15.8693 2.83642 15.7798C2.78758 15.6898 2.75868 15.5903 2.75167 15.4881C2.74467 15.386 2.75972 15.2835 2.79582 15.1876C2.83191 15.0918 2.8882 15.0048 2.96087 14.9327L2.96883 14.9248L11.3563 7.97061C11.5287 7.82606 11.7478 7.74748 11.9728 7.75006C12.1931 7.7507 12.4067 7.82616 12.5785 7.96411L12.5816 7.96657L20.9548 14.9078C21.0408 14.9715 21.1119 15.0533 21.163 15.1476C21.2155 15.2445 21.2456 15.3521 21.2508 15.4623L21.2513 15.4742C21.2512 15.5841 21.2259 15.6926 21.1778 15.7914C21.1298 15.8902 21.0599 15.9768 20.9734 16.0447L20.819 15.8481L20.816 15.8491Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const CardArrowExpandIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Card-arrow-expand"
}, "Card arrow expand"), /*#__PURE__*/React.createElement("path", {
  d: "M3.18395 8.1536L3.03109 7.95577C3.20374 7.82237 3.41576 7.75 3.63395 7.75C3.85213 7.75 4.06415 7.82237 4.2368 7.95577L4.24362 7.96103L12.0171 14.407L19.8175 7.95113L19.8305 7.9428C20.0024 7.83321 20.204 7.7794 20.4076 7.78875C20.6107 7.79806 20.8059 7.86973 20.9668 7.99397C21.0479 8.05537 21.115 8.13341 21.1636 8.22287C21.2124 8.31288 21.2413 8.41235 21.2483 8.51452C21.2553 8.6167 21.2403 8.71918 21.2042 8.81502C21.1681 8.91086 21.1118 8.99781 21.0391 9.06998L21.0312 9.07789L12.6437 16.032C12.4713 16.1766 12.2521 16.2552 12.0272 16.2526C11.8068 16.252 11.5933 16.1765 11.4214 16.0385L11.4184 16.0361L3.04522 9.09489C2.95915 9.03116 2.88805 8.94931 2.83698 8.85508C2.78443 8.75813 2.75443 8.65056 2.74922 8.54039L2.74866 8.52841C2.74874 8.41852 2.77405 8.31008 2.82214 8.21127C2.87022 8.11246 2.94011 8.02585 3.02653 7.95798L3.18095 8.1546C3.18095 8.15461 3.18096 8.1546 3.18095 8.1546L3.18395 8.1536Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const CircleArrowDownIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Circle-arrow-down"
}, "Circle arrow down"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_126)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.049 6.50202C11.6519 6.50202 11.33 6.81584 11.33 7.20296L11.33 15.1096L8.72843 12.6634C8.4483 12.3891 7.99311 12.3881 7.71172 12.6612C7.43033 12.9343 7.4293 13.3781 7.70942 13.6525L11.4289 17.2954C11.5825 17.4458 11.7887 17.514 11.99 17.5C12.1912 17.5149 12.3977 17.4475 12.5519 17.2978L16.2883 13.6713C16.5697 13.3982 16.5707 12.9544 16.2906 12.6801C16.0105 12.4057 15.5553 12.4047 15.2739 12.6778L12.7679 15.1101L12.7679 7.20297C12.7679 6.81584 12.446 6.50202 12.049 6.50202Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM12 -1.04907e-06C5.37259 -1.62846e-06 1.62846e-06 5.37258 1.04907e-06 12C4.69686e-07 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 -4.69686e-07 12 -1.04907e-06Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_126"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const CircleArrowLeftIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Circle-arrow-left"
}, "Circle arrow left"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_169)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.498 12.0489C17.498 11.6519 17.1842 11.33 16.797 11.33L8.8904 11.33L11.3366 8.72842C11.6109 8.4483 11.6119 7.9931 11.3388 7.71172C11.0657 7.43033 10.6219 7.4293 10.3475 7.70942L6.70463 11.4289C6.55422 11.5825 6.48597 11.7887 6.5 11.99C6.48511 12.1912 6.55246 12.3977 6.70216 12.5519L10.3287 16.2883C10.6018 16.5697 11.0456 16.5707 11.3199 16.2906C11.5943 16.0105 11.5953 15.5553 11.3222 15.2739L8.88985 12.7679L16.797 12.7679C17.1842 12.7679 17.498 12.446 17.498 12.0489Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12ZM24 12C24 5.37258 18.6274 -8.1423e-07 12 -5.24537e-07C5.37258 -2.34843e-07 -8.1423e-07 5.37258 -5.24537e-07 12C-2.34843e-07 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_169"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const CircleArrowRightIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Circle-arrow-right"
}, "Circle arrow right"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_162)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.50202 11.951C6.50202 12.3481 6.81584 12.67 7.20296 12.67L15.1096 12.67L12.6634 15.2716C12.3891 15.5517 12.3881 16.0069 12.6612 16.2883C12.9343 16.5697 13.3781 16.5707 13.6525 16.2906L17.2954 12.5711C17.4458 12.4175 17.514 12.2113 17.5 12.01C17.5149 11.8088 17.4475 11.6023 17.2978 11.4481L13.6713 7.71172C13.3982 7.43033 12.9544 7.4293 12.6801 7.70942C12.4057 7.98954 12.4047 8.44474 12.6778 8.72613L15.1101 11.2321L7.20297 11.2321C6.81584 11.2321 6.50202 11.554 6.50202 11.951Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12ZM-5.24537e-07 12C-8.1423e-07 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 -2.34843e-07 12 -5.24537e-07C5.37258 -8.1423e-07 -2.34843e-07 5.37258 -5.24537e-07 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_162"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const CircleArrowUpIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Circle-arrow-up"
}, "Circle arrow up"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_173)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.951 17.498C12.3481 17.498 12.67 17.1842 12.67 16.797V8.8904L15.2716 11.3366C15.5517 11.6109 16.0069 11.6119 16.2883 11.3388C16.5697 11.0657 16.5707 10.6219 16.2906 10.3475L12.5711 6.70463C12.4175 6.55422 12.2113 6.48597 12.01 6.5C11.8088 6.48511 11.6023 6.55246 11.4481 6.70216L7.71172 10.3287C7.43033 10.6018 7.4293 11.0456 7.70942 11.3199C7.98954 11.5943 8.44474 11.5953 8.72613 11.3222L11.2321 8.88985V16.797C11.2321 17.1842 11.554 17.498 11.951 17.498Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_173"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const CursorArrowIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Cursor-arrow"
}, "Cursor arrow"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_120)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_2_120)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 13.5L18 12L6 5L9.5 18L12.5 14.5L16 19L17.5 18L14 13.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.8119 13.7295L18.1756 12.4682L19.1612 12.0985L18.2519 11.5681L6.25194 4.56811L5.20084 3.95497L5.51719 5.12999L9.01719 18.13L9.26337 19.0444L9.87963 18.3254L12.4812 15.2902L15.6053 19.307L15.8907 19.6738L16.2774 19.416L17.7774 18.416L18.2249 18.1176L17.8947 17.693L14.8119 13.7295Z",
  stroke: "white"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_2_120",
  x: 1.40173,
  y: 0.909912,
  width: 21.9208,
  height: 23.4377,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2_120"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2_120",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_120"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const CursorHandIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Cursor-hand"
}, "Cursor hand"), /*#__PURE__*/React.createElement("path", {
  d: "M6.92932 0.955566L5.82703 2.32031L5.51199 10.6146H2.15233V13.1869L6.6144 20.3262V22.8984H15.9585L18.1108 17.0715V9.5647L9.86909 5.47009V2.32031L9.08166 1.74295L8.6617 0.955566H6.92932Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.02254 0.399902H9.34614V1.34086H10.2768V5.12276H12.1294V6.06371H14.9038V7.00466H16.7475V7.95466H17.6782V8.89562H18.6V17.9361H17.6782V20.768H16.7475V23.5999H6.02254L6.02254 20.768L5.09183 20.768L5.09183 18.8771L4.16999 18.877V16.9951H3.24814V15.1042H2.31744V14.1598L1.40002 14.1544V9.8423L5.09231 9.83627C5.09275 8.94738 5.09347 7.67631 5.09449 6.33558L5.09657 1.34929L6.02254 1.3445V0.399902ZM4.4499 11.0373L2.60002 11.0403V12.9614L3.51744 12.9651V13.9042H4.44814V15.7951H5.36999V17.6771L6.29183 17.6771L6.29183 19.568L7.22254 19.568L7.22254 22.3999H15.5475V19.568H16.4782V16.7361H17.4V10.0956H16.5094V13.1587H15.3094V8.20466H13.7038V7.26371H13.2V11.4683H12V7.26371H10.9294V6.32276H10.2814V10.7556H9.08137L9.08137 6.32276H9.07684V2.54086H8.14614V1.5999H7.22254V2.5383L6.29607 2.5431L6.29449 6.33628C6.29272 8.67234 6.29183 10.7968 6.29183 11.0562V11.9866H6.2876V13.5745H5.0876V11.9866L4.4499 11.9866L4.4499 11.0373Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const CursorHandDragIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Cursor-hand-drag"
}, "Cursor hand drag"), /*#__PURE__*/React.createElement("path", {
  d: "M7.89795 5.61548L6.77612 6.40747L3.87242 6.01145L1.56263 7.99122V10.4989H2.55256V12.6107L6.77612 18.484V20.1998H7.89795V21.8496H19.1167V18.1541H20.1725V15.5144H21.0964V6.80336H20.1725V5.21954H18.5887L17.2029 4.49362L16.213 3.43773L13.4413 2.44782L12.0555 1.45802L11.0656 2.44782H9.34978L7.89795 3.43773V5.61548Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.556 6.44188V4.67888H17.911V3.79088H17.028V2.91588H14.384V2.02988H13.501V1.15088H10.851V2.02888H8.20602V2.91388H7.32302V5.55488H2.91402V6.43988H2.03002V7.31788H1.15002V10.8439H2.03102V13.4959H2.91402V14.3809H3.79502V16.1439H4.67802V17.9069H5.55902V18.7909H6.44202V20.5539H7.32302V22.3169H19.677V18.7909H20.558V16.1519H21.441V6.45188L20.556 6.44188Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.556 6.44188V4.67888H17.911V3.79088H17.028V2.91588H14.384V2.02988H13.501V1.15088H10.851V2.02888H8.20602V2.91388H7.32302V5.55488H2.91402V6.43988H2.03002V7.31788H1.15002V10.8439H2.03102V13.4959H2.91402V14.3809H3.79502V16.1439H4.67802V17.9069H5.55902V18.7909H6.44202V20.5539H7.32302V22.3169H19.677V18.7909H20.558V16.1519H21.441V6.45188L20.556 6.44188ZM20.556 8.20588V15.2599H19.675V17.9079H18.792V21.4339H8.20502V19.6719H7.32202V17.9079H6.44102V17.0249H5.55802V15.2619H4.67902V13.4989H3.79502V12.6189H2.91502V9.96988H2.03102V8.20688H2.91402V7.32188H3.79502V6.44388H5.55902V7.32188H6.44202V9.08488H5.55902V9.96988H6.44202V10.8479H7.32302V6.44788H8.20602V3.79088H9.08402V2.91688H9.96702V6.44388H10.848V2.91688H11.731V2.02988H12.616V2.91488H13.497V6.44088H14.384V3.79088H16.148V4.67588H17.029V8.20188H17.912V5.55588H19.676V7.31888H20.557L20.556 8.20588Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.89795 5.61548L6.77612 6.40747L3.87242 6.01145L1.56263 7.99122V10.4989H2.55256V12.6107L6.77612 18.484V20.1998H7.89795V21.8496H19.1167V18.1541H20.1725V15.5144H21.0964V6.80336H20.1725V5.21954H18.5887L17.2029 4.49362L16.213 3.43773L13.4413 2.44782L12.0555 1.45802L11.0656 2.44782H9.34978L7.89795 3.43773V5.61548Z",
  stroke: "#404040",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.556 6.44188V4.67888H17.911V3.79088H17.028V2.91588H14.384V2.02988H13.501V1.15088H10.851V2.02888H8.20602V2.91388H7.32302V5.55488H2.91402V6.43988H2.03002V7.31788H1.15002V10.8439H2.03102V13.4959H2.91402V14.3809H3.79502V16.1439H4.67802V17.9069H5.55902V18.7909H6.44202V20.5539H7.32302V22.3169H19.677V18.7909H20.558V16.1519H21.441V6.45188L20.556 6.44188Z",
  stroke: "#404040",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.556 6.44188V4.67888H17.911V3.79088H17.028V2.91588H14.384V2.02988H13.501V1.15088H10.851V2.02888H8.20602V2.91388H7.32302V5.55488H2.91402V6.43988H2.03002V7.31788H1.15002V10.8439H2.03102V13.4959H2.91402V14.3809H3.79502V16.1439H4.67802V17.9069H5.55902V18.7909H6.44202V20.5539H7.32302V22.3169H19.677V18.7909H20.558V16.1519H21.441V6.45188L20.556 6.44188ZM20.556 8.20588V15.2599H19.675V17.9079H18.792V21.4339H8.20502V19.6719H7.32202V17.9079H6.44102V17.0249H5.55802V15.2619H4.67902V13.4989H3.79502V12.6189H2.91502V9.96988H2.03102V8.20688H2.91402V7.32188H3.79502V6.44388H5.55902V7.32188H6.44202V9.08488H5.55902V9.96988H6.44202V10.8479H7.32302V6.44788H8.20602V3.79088H9.08402V2.91688H9.96702V6.44388H10.848V2.91688H11.731V2.02988H12.616V2.91488H13.497V6.44088H14.384V3.79088H16.148V4.67588H17.029V8.20188H17.912V5.55588H19.676V7.31888H20.557L20.556 8.20588Z",
  stroke: "#404040",
  strokeWidth: 0.3
}));
export const CursorTypeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Cursor-type"
}, "Cursor type"), /*#__PURE__*/React.createElement("path", {
  d: "M15.4997 23C14.2277 23 13.1124 22.3181 12.4996 21.3009C11.8869 22.3183 10.7716 23.0001 9.49968 23.0001C9.22406 23.0001 9 22.776 9 22.5004C9 22.2238 9.22406 21.9998 9.49968 21.9998C10.8778 21.9998 12 20.8776 12 19.4995V12.9997H10.4991C10.2235 12.9997 9.99939 12.7757 9.99939 12.5C9.99939 12.2244 10.2235 12.0004 10.5 12.0004H12V4.49978C12 3.12165 10.8778 2.00042 9.49968 2.00042C9.22406 2.00042 9 1.77636 9 1.4998C9 1.22419 9.22406 1.00012 9.49968 1.00012C10.7717 1.00012 11.887 1.68202 12.4997 2.6992C13.1125 1.68183 14.2277 1 15.4997 1C15.7753 1 15.9994 1.22406 15.9994 1.49968C15.9994 1.77623 15.7753 2.0003 15.4997 2.0003C14.1216 2.0003 12.9994 3.12249 12.9994 4.50062V12.0004H14.5003C14.7759 12.0004 15 12.2244 15 12.5C15 12.7757 14.7759 12.9997 14.4994 12.9997H12.9994V19.5003C12.9994 20.8784 14.1216 22.0006 15.4997 22.0006C15.7753 22.0006 15.9994 22.2247 15.9994 22.5003C15.9994 22.7759 15.7753 23 15.4997 23Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const DragIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Drag"
}, "Drag"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9857 3C11.9672 3.0008 11.9496 3.00161 11.9311 3.00402C11.9254 3.00482 11.9206 3.00482 11.915 3.00563L11.8981 3.00804C11.8933 3.00884 11.8877 3.00964 11.8821 3.01045C11.8604 3.01527 11.8387 3.02089 11.8178 3.02732C11.8129 3.02812 11.8081 3.02973 11.8033 3.03054C11.8009 3.03214 11.7977 3.03295 11.7945 3.03375C11.7607 3.0458 11.7278 3.05946 11.6964 3.07714C11.6932 3.07875 11.6892 3.08036 11.686 3.08196C11.6812 3.08437 11.6771 3.08679 11.6723 3.09C11.6683 3.09241 11.6643 3.09482 11.6603 3.09723C11.6297 3.11652 11.6008 3.13821 11.5735 3.16232C11.5687 3.16634 11.5638 3.17116 11.559 3.17598C11.5558 3.1792 11.5518 3.18241 11.5478 3.18562C11.5478 3.18643 11.547 3.18723 11.547 3.18723C11.5389 3.19446 11.5317 3.2025 11.5245 3.20973L8.97462 5.75953C8.72389 6.01025 8.72389 6.41765 8.97462 6.66837C9.22534 6.91909 9.63274 6.91909 9.88347 6.66837L11.3572 5.19463V11.3563H5.19544L6.6684 9.88338C6.91913 9.63186 6.91913 9.22607 6.6684 8.97454C6.54385 8.8508 6.37429 8.78249 6.1983 8.78731C6.03357 8.79133 5.87687 8.85803 5.75955 8.97454L3.22822 11.5081C3.08358 11.6302 3 11.8102 3 11.9999C3 12.1654 3.06429 12.3245 3.1792 12.4442C3.18884 12.4547 3.19929 12.4651 3.21054 12.4748L5.76038 15.0246L5.75958 15.0254C6.0111 15.2761 6.4177 15.2761 6.66843 15.0254C6.91915 14.7739 6.91915 14.3673 6.66843 14.1166L5.19466 12.6428H11.3573V18.8053L9.88351 17.3308C9.75896 17.207 9.5894 17.1395 9.41341 17.1435C9.24868 17.1476 9.09198 17.2143 8.97466 17.3308C8.72394 17.5823 8.72394 17.9889 8.97466 18.2396L11.5469 20.8118C11.5622 20.8279 11.5791 20.8424 11.5968 20.8568C11.6032 20.8617 11.6104 20.8673 11.6168 20.8721C11.6217 20.8761 11.6265 20.8793 11.6313 20.8826C11.6361 20.8858 11.641 20.889 11.645 20.8922C11.6514 20.8962 11.657 20.9002 11.6635 20.9042C11.6659 20.9059 11.6691 20.9075 11.6715 20.9091C11.6908 20.9203 11.7101 20.9308 11.7301 20.9396C11.735 20.942 11.7398 20.9444 11.7454 20.946C11.7518 20.9492 11.7583 20.9525 11.7647 20.9549C11.7719 20.9573 11.7792 20.9605 11.7864 20.9629C11.7904 20.9637 11.7944 20.9653 11.7985 20.9669C12.0291 21.0441 12.2838 20.9838 12.4558 20.8118L15.028 18.2396C15.2788 17.9889 15.2788 17.5823 15.028 17.3308C14.9075 17.2094 14.7428 17.1411 14.5724 17.1411C14.4013 17.1411 14.2373 17.2094 14.116 17.3308L12.643 18.8053V12.6428H18.8056L17.3319 14.1166C17.0811 14.3673 17.0811 14.7739 17.3319 15.0254C17.5826 15.2761 17.9892 15.2761 18.2399 15.0254L20.8122 12.4556V12.4548C20.9705 12.2965 21.0348 12.0659 20.9817 11.8481C20.9793 11.8385 20.9769 11.8289 20.9745 11.82C20.9737 11.8168 20.9729 11.8144 20.9713 11.812C20.9689 11.8023 20.9657 11.7927 20.9625 11.7831C20.9608 11.7806 20.96 11.7782 20.9592 11.775C20.956 11.7662 20.952 11.7573 20.948 11.7485C20.9424 11.734 20.9351 11.7196 20.9279 11.7059C20.9183 11.6858 20.907 11.6657 20.8942 11.6472C20.8925 11.6448 20.8909 11.6424 20.8893 11.64C20.8837 11.632 20.8781 11.6239 20.8725 11.6159C20.8708 11.6135 20.8692 11.6111 20.8676 11.6087C20.8532 11.591 20.8387 11.5741 20.8226 11.5573C20.821 11.5556 20.8194 11.5532 20.817 11.5508C20.8154 11.55 20.8138 11.5484 20.8122 11.5468L18.2399 8.97458C18.1162 8.85083 17.9458 8.78253 17.7706 8.78735C17.6059 8.79137 17.4484 8.85806 17.3319 8.97458C17.0812 9.2261 17.0812 9.63189 17.3319 9.88342L18.8049 11.3564H12.6431V5.19466L14.1168 6.66841H14.116C14.2374 6.78974 14.4013 6.85805 14.5725 6.85805C14.7428 6.85805 14.9076 6.78974 15.0281 6.66841C15.2788 6.41768 15.2788 6.01029 15.0281 5.75957L12.4558 3.18735C12.3385 3.07083 12.1818 3.00414 12.0163 3.00012H12.009H11.9857L11.9857 3Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const DragAltIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Drag-alt"
}, "Drag alt"), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 6C10.5 6.82843 9.82843 7.5 9 7.5C8.17157 7.5 7.5 6.82843 7.5 6C7.5 5.17157 8.17157 4.5 9 4.5C9.82843 4.5 10.5 5.17157 10.5 6Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 6C16.5 6.82843 15.8284 7.5 15 7.5C14.1716 7.5 13.5 6.82843 13.5 6C13.5 5.17157 14.1716 4.5 15 4.5C15.8284 4.5 16.5 5.17157 16.5 6Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 12C10.5 12.8284 9.82843 13.5 9 13.5C8.17157 13.5 7.5 12.8284 7.5 12C7.5 11.1716 8.17157 10.5 9 10.5C9.82843 10.5 10.5 11.1716 10.5 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 12C16.5 12.8284 15.8284 13.5 15 13.5C14.1716 13.5 13.5 12.8284 13.5 12C13.5 11.1716 14.1716 10.5 15 10.5C15.8284 10.5 16.5 11.1716 16.5 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 18C10.5 18.8284 9.82843 19.5 9 19.5C8.17157 19.5 7.5 18.8284 7.5 18C7.5 17.1716 8.17157 16.5 9 16.5C9.82843 16.5 10.5 17.1716 10.5 18Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 18C16.5 18.8284 15.8284 19.5 15 19.5C14.1716 19.5 13.5 18.8284 13.5 18C13.5 17.1716 14.1716 16.5 15 16.5C15.8284 16.5 16.5 17.1716 16.5 18Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const DropdownArrowDownIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Dropdown-arrow-down"
}, "Dropdown arrow down"), /*#__PURE__*/React.createElement("path", {
  d: "M12 14L7 9H17L12 14Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const DropdownArrowUpIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Dropdown-arrow-up"
}, "Dropdown arrow up"), /*#__PURE__*/React.createElement("path", {
  d: "M12 9L17 14L7 14L12 9Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const DropdownCollapseLineIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Dropdown-collapse-line"
}, "Dropdown collapse line"), /*#__PURE__*/React.createElement("path", {
  d: "M4 4.5C4 4.22386 3.77614 4 3.5 4C3.22386 4 3 4.22386 3 4.5V19.5C3 19.7761 3.22386 20 3.5 20C3.77614 20 4 19.7761 4 19.5V4.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 14L16 9L11 14L21 14Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const DropdownExpandLineIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Dropdown-expand-line"
}, "Dropdown expand line"), /*#__PURE__*/React.createElement("path", {
  d: "M4 4.5C4 4.22386 3.77614 4 3.5 4C3.22386 4 3 4.22386 3 4.5V19.5C3 19.7761 3.22386 20 3.5 20C3.77614 20 4 19.7761 4 19.5V4.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 10L16 15L21 10H11Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const ExternalLinkIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-External-link"
}, "External link"), /*#__PURE__*/React.createElement("path", {
  d: "M9.25 2C9.66421 2 10 2.33579 10 2.75C10 3.16421 9.66421 3.5 9.25 3.5H3.5V20.5H20.5V14.75C20.5 14.3358 20.8358 14 21.25 14C21.6642 14 22 14.3358 22 14.75V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V3C2 2.44772 2.44772 2 3 2H9.25Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2499 2C14.8357 2 14.4999 2.33579 14.4999 2.75C14.4999 3.16421 14.8357 3.5 15.2499 3.5H19.3786L12.9843 9.89429C12.6914 10.1872 12.6914 10.6621 12.9843 10.955C13.2772 11.2478 13.7521 11.2478 14.045 10.955L20.4999 4.5V8.25C20.4999 8.66421 20.8357 9 21.2499 9C21.6641 9 21.9999 8.66421 21.9999 8.25V2.75C21.9999 2.33579 21.6641 2 21.2499 2H15.2499Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const LinkArrowCollapseIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Link-arrow-collapse"
}, "Link arrow collapse"), /*#__PURE__*/React.createElement("path", {
  d: "M11.897 9.5C11.7231 9.51703 11.5546 9.58272 11.4212 9.69707L7.21982 13.3005C6.90651 13.5693 6.94766 13.9719 7.21982 14.2737C7.49199 14.5754 7.99915 14.5754 8.35442 14.2737L11.9979 11.1487L15.6456 14.2737C16.0009 14.5754 16.508 14.5754 16.7802 14.2737C17.0523 13.9719 17.0935 13.5693 16.7802 13.3005L12.5788 9.69707C12.4454 9.58272 12.2769 9.51703 12.103 9.5L11.897 9.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const LinkArrowExpandIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Link-arrow-expand"
}, "Link arrow expand"), /*#__PURE__*/React.createElement("path", {
  d: "M12.103 14.5C12.2769 14.483 12.4454 14.4173 12.5788 14.3029L16.7802 10.6995C17.0935 10.4307 17.0523 10.0281 16.7802 9.72634C16.508 9.42455 16.0009 9.42455 15.6456 9.72634L12.0021 12.8513L8.35442 9.72634C7.99915 9.42455 7.49199 9.42455 7.21983 9.72634C6.94766 10.0281 6.90651 10.4307 7.21983 10.6995L11.4212 14.3029C11.5546 14.4173 11.7231 14.483 11.897 14.5H12.103Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const MainAppsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Main-apps"
}, "Main apps"), /*#__PURE__*/React.createElement("path", {
  d: "M2 3C2 2.44772 2.44772 2 3 2H5C5.55228 2 6 2.44772 6 3V5C6 5.55228 5.55228 6 5 6H3C2.44772 6 2 5.55228 2 5V3Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 11C2 10.4477 2.44772 10 3 10H5C5.55228 10 6 10.4477 6 11V13C6 13.5523 5.55228 14 5 14H3C2.44772 14 2 13.5523 2 13V11Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 19C6 18.4477 5.55228 18 5 18H3C2.44772 18 2 18.4477 2 19V21C2 21.5523 2.44772 22 3 22H5C5.55228 22 6 21.5523 6 21V19Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 3C10 2.44772 10.4477 2 11 2H13C13.5523 2 14 2.44772 14 3V5C14 5.55228 13.5523 6 13 6H11C10.4477 6 10 5.55228 10 5V3Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 11C14 10.4477 13.5523 10 13 10H11C10.4477 10 10 10.4477 10 11V13C10 13.5523 10.4477 14 11 14H13C13.5523 14 14 13.5523 14 13V11Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 19C10 18.4477 10.4477 18 11 18H13C13.5523 18 14 18.4477 14 19V21C14 21.5523 13.5523 22 13 22H11C10.4477 22 10 21.5523 10 21V19Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 3C22 2.44772 21.5523 2 21 2H19C18.4477 2 18 2.44772 18 3V5C18 5.55228 18.4477 6 19 6H21C21.5523 6 22 5.55228 22 5V3Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 11C18 10.4477 18.4477 10 19 10H21C21.5523 10 22 10.4477 22 11V13C22 13.5523 21.5523 14 21 14H19C18.4477 14 18 13.5523 18 13V11Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 19C22 18.4477 21.5523 18 21 18H19C18.4477 18 18 18.4477 18 19V21C18 21.5523 18.4477 22 19 22H21C21.5523 22 22 21.5523 22 21V19Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const MenuIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Menu"
}, "Menu"), /*#__PURE__*/React.createElement("path", {
  d: "M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H4C3.44772 7 3 6.55228 3 6Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 17C3.44772 17 3 17.4477 3 18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18C21 17.4477 20.5523 17 20 17H4Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const NumberInputArrowsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Number-input-arrows"
}, "Number input arrows"), /*#__PURE__*/React.createElement("path", {
  d: "M17 9L12 4L7 9H17Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 15L12 20L17 15H7Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const PaginationFirstIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pagination-first"
}, "Pagination first"), /*#__PURE__*/React.createElement("path", {
  d: "M6 12.103C6.01703 12.2769 6.08272 12.4454 6.19707 12.5788L9.80054 16.7802C10.0693 17.0935 10.4719 17.0523 10.7737 16.7802C11.0754 16.508 11.0754 16.0009 10.7737 15.6456L7.64869 12.0021L10.7737 8.35442C11.0754 7.99915 11.0754 7.49199 10.7737 7.21983C10.4719 6.94766 10.0693 6.90651 9.80054 7.21983L6.19707 11.4212C6.08272 11.5546 6.01703 11.7231 6 11.897L6 12.103Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 12.103C13.017 12.2769 13.0827 12.4454 13.1971 12.5788L16.8005 16.7802C17.0693 17.0935 17.4719 17.0523 17.7737 16.7802C18.0754 16.508 18.0754 16.0009 17.7737 15.6456L14.6487 12.0021L17.7737 8.35442C18.0754 7.99915 18.0754 7.49199 17.7737 7.21983C17.4719 6.94766 17.0693 6.90651 16.8005 7.21983L13.1971 11.4212C13.0827 11.5546 13.017 11.7231 13 11.897V12.103Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const PaginationLastIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pagination-last"
}, "Pagination last"), /*#__PURE__*/React.createElement("path", {
  d: "M18 11.897C17.983 11.7231 17.9173 11.5546 17.8029 11.4212L14.1995 7.21983C13.9307 6.90651 13.5281 6.94766 13.2263 7.21983C12.9246 7.49199 12.9246 7.99915 13.2263 8.35442L16.3513 11.9979L13.2263 15.6456C12.9246 16.0009 12.9246 16.508 13.2263 16.7802C13.5281 17.0523 13.9307 17.0935 14.1995 16.7802L17.8029 12.5788C17.9173 12.4454 17.983 12.2769 18 12.103L18 11.897Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 11.897C10.983 11.7231 10.9173 11.5546 10.8029 11.4212L7.19946 7.21982C6.93074 6.90651 6.52812 6.94766 6.22634 7.21982C5.92455 7.49199 5.92455 7.99915 6.22634 8.35442L9.35131 11.9979L6.22634 15.6456C5.92455 16.0009 5.92455 16.508 6.22634 16.7802C6.52812 17.0523 6.93074 17.0935 7.19946 16.7802L10.8029 12.5788C10.9173 12.4454 10.983 12.2769 11 12.103L11 11.897Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const PaginationNextIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pagination-next"
}, "Pagination next"), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 11.397C14.483 11.2231 14.4173 11.0546 14.3029 10.9212L10.6995 6.71982C10.4307 6.40651 10.0281 6.44766 9.72634 6.71982C9.42455 6.99199 9.42455 7.49915 9.72634 7.85442L12.8513 11.4979L9.72634 15.1456C9.42455 15.5009 9.42455 16.008 9.72634 16.2802C10.0281 16.5523 10.4307 16.5935 10.6995 16.2802L14.3029 12.0788C14.4173 11.9454 14.483 11.7769 14.5 11.603L14.5 11.397Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const PaginationPreviousIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pagination-previous"
}, "Pagination previous"), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 11.603C9.51703 11.7769 9.58272 11.9454 9.69707 12.0788L13.3005 16.2802C13.5693 16.5935 13.9719 16.5523 14.2737 16.2802C14.5754 16.008 14.5754 15.5009 14.2737 15.1456L11.1487 11.5021L14.2737 7.85442C14.5754 7.49915 14.5754 6.99199 14.2737 6.71983C13.9719 6.44766 13.5693 6.40651 13.3005 6.71983L9.69707 10.9212C9.58272 11.0546 9.51703 11.2231 9.5 11.397L9.5 11.603Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const RefreshIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Refresh"
}, "Refresh"), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 12.25C3.5 7.96979 6.96979 4.5 11.25 4.5C15.2274 4.5 18.5049 7.49616 18.9488 11.3546L16.7792 9.77343C16.4847 9.55876 16.0766 9.64566 15.8678 9.96754C15.6591 10.2894 15.7286 10.7244 16.0232 10.9391L18.7817 12.9491L18.78 12.9578L18.7987 12.9614L19.349 13.3624L19.3517 13.3649C19.4597 13.4634 19.5904 13.5162 19.7236 13.5251C19.9504 13.543 20.1827 13.4328 20.3239 13.2151L20.3323 13.2018L22.8312 10.1164C23.0712 9.82016 23.047 9.3783 22.7772 9.12948C22.5074 8.8806 22.0942 8.91906 21.8542 9.21534L20.4152 10.9921C19.8015 6.47851 15.932 3 11.25 3C6.14137 3 2 7.14137 2 12.25C2 17.3586 6.14137 21.5 11.25 21.5C13.9605 21.5 16.3989 20.3335 18.0898 18.4774C18.3688 18.1712 18.3063 17.6978 17.9786 17.4444C17.651 17.1911 17.1824 17.2543 16.8987 17.5561C15.4843 19.0614 13.4769 20 11.25 20C6.96979 20 3.5 16.5302 3.5 12.25Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const TableFilterSortIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Table-filter-sort"
}, "Table filter sort"), /*#__PURE__*/React.createElement("path", {
  d: "M20.5001 3C20.7763 3 21.0001 3.22386 21.0001 3.5V19.5C21.0001 19.7761 20.7763 20 20.5001 20C20.224 20 20.0001 19.7761 20.0001 19.5V3.5C20.0001 3.22386 20.224 3 20.5001 3Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.00005 6L11.3302 10.5H2.66992L7.00005 6Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.66992 13.5L7.00005 18L11.3302 13.5L2.66992 13.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const TableFilterSortDescendingIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Table-filter-sort-descending"
}, "Table filter sort descending"), /*#__PURE__*/React.createElement("path", {
  d: "M7.00009 18.8596C7.55237 18.8596 8.00009 18.4118 8.00009 17.8596L8.00009 10.8596L10.9326 10.8596C11.3565 10.8596 11.5881 10.3651 11.3167 10.0395L7.3842 5.32049C7.1843 5.08061 6.81587 5.08061 6.61597 5.32049L2.6835 10.0395C2.41211 10.3651 2.64369 10.8596 3.06761 10.8596L6.00009 10.8596L6.00009 17.8596C6.00009 18.4118 6.4478 18.8596 7.00009 18.8596Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5 3.5C20.7762 3.5 21 3.72386 21 4L21 20C21 20.2761 20.7762 20.5 20.5 20.5C20.2239 20.5 20 20.2761 20 20L20 4C20 3.72386 20.2239 3.5 20.5 3.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));